import Bloc from './Bloc.js';
import Types from './Types.js';

export default class ForEachEvent extends Bloc {

	constructor (src, ctx) {

		super("forevent", src, ctx, true);
		this.f = (src, ins, props) => {
			var logs = [];
			switch (ins[1]) {
				case 0: logs = this.logsAllGame(src.master, ins[0], props); break;
				case 1: logs = this.logsThisTurn(src.master, ins[0], props); break;
				case 2: logs = this.logsLastEvent(src.master, ins[0], props); break;
				default: break;
			}

			logs.forEach (log => {
				this.out = [log.data.map(e => e && e.type && e.no ? src.master.find(e) : e)];
				if (this["for each"])
					this["for each"].execute(props);
			})
			this.out = null;
			if (this.completed)
				this.completed.execute(props);
			return;
		}
		this.types = [Types.event, Types.period, Types.bool, Types.int];
		this.toPrepare.push("for each");
		this.toPrepare.push("completed");
	}

	execute (props) {
		
		props = props || {};
		let src = props.src || this.src;
		props.trace = props.trace || [];
		props.trace.push(this);
		var f = this.f || (() => []);
		this.out = f(src, [this.in[0](props), this.in[1](props)], props);
	}

	logsThisTurn (master, event, props) {

		let c = [];
		(master.run?.broadcaster?.log || master.run.log).forEach(log => {
			if (log.type === "playerturn")
				c = [];
			let nprops = Object.assign({}, props);
			nprops.data = nprops.data || {};
			let code = this.in[3] ? (this.in[3]({src: this.src}) || 0) : 0;
			nprops.data[code] = log.data;
			if (event === log.type && this.in[2](nprops))
				c.push(log);
		})
		return c;
	}

	logsLastEvent (master, event, props) {

		let c = [];
		(master.run?.broadcaster?.log || master.run.log).forEach(log => {
			if (log.type === "playerturn")
				c = [];
			let nprops = Object.assign({}, props);
			nprops.data = nprops.data || {};
			let code = this.in[3] ? (this.in[3]({src: this.src}) || 0) : 0;
			nprops.data[code] = log.data;
			if (event === log.type && this.in[2](nprops)) {
				c = [];
				c.push(log);
			} /*else if (event == log.type)
				c = [];*/
		})
		return c;
	}

	logsOpponentsTurn (master, event, props) {

		let c = [], you = false;
		(master.run?.broadcaster?.log || master.run.log).log.forEach(log => {
			if (log.type === "playerturn") {
				if (log.data[0].id.no !== this.src.player.id.no) {
					you = false;
					c = [];
				} else you = true;
			}
			if (you)
				return;
			let nprops = Object.assign({}, props);
			nprops.data = nprops.data || {};
			let code = this.in[3] ? (this.in[3]({src: this.src}) || 0) : 0;
			nprops.data[code] = log.data;
			if (event === log.type && this.in[2](nprops))
				c.push(log);
		})
		return c;
	}

	logsSincePreviousTurn (master, event, props) {

		let c = [];
		(master.run?.broadcaster?.log || master.run.log).log.forEach(log => {
			if (log.type === "newturn" && log.data[0].id.no !== this.src.player.id.no)
				c = [];
			let nprops = Object.assign({}, props);
			nprops.data = nprops.data || {};
			let code = this.in[3] ? (this.in[3]({src: this.src}) || 0) : 0;
			nprops.data[code] = log.data;
			if (event.check(log.type, log.data) && this.in[2](nprops))
				c.push(log);
		})
		return c;
	}

	logsPreviousTurn (master, event, props) {

		let c = [], n = [], you = false;
		(master.run?.broadcaster?.log || master.run.log).log.forEach(log => {
			if (log.type === "newturn") {
				if (log.data[0].id.no === this.src.player.id.no) {
					you = true;
					c = n;
					n = [];
				} else you = false;
			}
			if (!you)
				return;
			let nprops = Object.assign({}, props);
			nprops.data = nprops.data || {};
			let code = this.in[3] ? (this.in[3]({src: this.src}) || 0) : 0;
			nprops.data[code] = log.data;
			if (event.check(log.type, log.data) && this.in[2](nprops))
				n.push(log);
		})
		return c;
	}

	logsAllGame (master, event, props) {

		return (master.run?.broadcaster?.log || master.run.log).filter(log => {
			let nprops = Object.assign({}, props);
			nprops.data = nprops.data || {};
			let code = this.in[3] ? (this.in[3]({src: this.src}) || 0) : 0;
			nprops.data[code] = log.data;
			return event === log.type && this.in[2](nprops)
		});
	}
}